import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

// style
import "./assets/style.css";

// toastify
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Components
import Sidebar from "./components/Sidebar";
import Dashboard from "./components/tabs/Dashboard";
import Orders from "./components/tabs/Orders";
import Transactions from "./components/tabs/Transactions";
import Downloads from "./components/tabs/Downloads";
import Profile from "./components/tabs/Profile";
import Address from "./components/tabs/Address";
import Password from "./components/tabs/Password";
import SingleOrder from "./components/tabs/Orders/SingleOrder";

const App = () => {
	const [activeTab, setActiveTab] = useState(null);
	const [showSingleOrder, setShowSingleOrder] = useState(false);
	const [orderId, setOrderId] = useState(null);

	useEffect(() => {
		const validTabs = [
			"dashboard",
			"orders",
			"transactions",
			"downloads",
			"profile",
			"address",
			"password",
		];

		const singleOrderRegex = /orders\/(\d+)/;

		const handleHashChange = () => {
			const newHash = window.location.hash.replace("#", "");

			if (newHash === "") {
				setActiveTab("dashboard");
			} else if (newHash && validTabs.includes(newHash)) {
				setActiveTab(newHash);
				setShowSingleOrder(false);
				window.location.hash = `#${newHash}`;
			} else if (newHash && newHash.match(singleOrderRegex)) {
				setActiveTab("orders");
				setShowSingleOrder(true);
				const match = newHash.match(singleOrderRegex);
				setOrderId(match[1]);
			}
		};

		window.addEventListener("hashchange", handleHashChange);

		// Initial check to ensure correct tab is set on page load
		handleHashChange();

		return () => {
			window.removeEventListener("hashchange", handleHashChange);
		};
	}, []);

	return (
		<>
			<div className="w-full flex flex-col gap-[50px] py-10">
				<div className="w-full flex border easycommerce-sidebar ec-db-md:flex-row flex-col border-ec-border rounded-lg">
					<Sidebar activeTab={activeTab} />

					<div className="easycommerce-dashboard-content-details ec-db-md:w-[calc(100%_-_268px)] w-full p-3 sm:p-[30px]">
						{activeTab === "dashboard" && <Dashboard />}
						{activeTab === "orders" && !showSingleOrder && (
							<Orders />
						)}
						{activeTab === "orders" && showSingleOrder && (
							<SingleOrder orderId={orderId} />
						)}
						{activeTab === "transactions" && <Transactions />}
						{activeTab === "downloads" && <Downloads />}
						{activeTab === "profile" && <Profile />}
						{activeTab === "address" && <Address />}
						{activeTab === "password" && <Password />}
					</div>
				</div>
			</div>

			<ToastContainer />
		</>
	);
};

const container = document.getElementById("easycommerce_dashboard_render");
const root = createRoot(container);
root.render(<App />);
